import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Button } from 'antd';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { PageProps } from '@/types/PageProps';

import SpaceForButton from '@/components/_common/SpaceForButtons';
import TransportList from '@/components/transport/TransportList';
import { useDisclosure } from '@/hooks';
import { useState } from 'react';
import InvoiceTransportCreateModal from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceTransportForm/InvoiceTransportCreateModal';

const TransportPage = ({ route }: PageProps) => {
  const intl = useIntl();

  const [modalVisible, setModalVisible] = useDisclosure(false);
  const [carrierId, setCarrierId] = useState<number>();

  const handleModalOpen = (carrierId?: number) => {
    setCarrierId(carrierId);
    setModalVisible.open();
  };

  return (
    <>
      <TabContentWrapper
        permissions={route.permissions}
        title={route.name}
        extra={
          <SpaceForButton>
            <Button block type="primary" onClick={() => handleModalOpen()}>
              {intl.formatMessage({
                id: 'layout.menu.registry.transport.create',
              })}
            </Button>
          </SpaceForButton>
        }
      >
        <Helmet title={intl.formatMessage({ id: route.name })} />

        <TransportList handleModalOpen={handleModalOpen} />
      </TabContentWrapper>

      <InvoiceTransportCreateModal
        visible={modalVisible}
        toggleModal={setModalVisible.toggle}
        carrierId={carrierId}
        resetCarrierId={() => setCarrierId(undefined)}
      />
    </>
  );
};

export default TransportPage;
